export default {
  title: '테마 진행 설명',
  mindMap: '마인드맵',
  documentTitle: '{name} 테마 진행 설명',
  introduction: '이 문서는 모든 장면의 통과 판정 조건, 조건 간의 AND/OR 관계 및 통과 동작을 나열합니다. 동작은 동작 행 순서대로 표시되며 각 행의 지연, 매개변수 및 동작 설명을 모두 포함합니다.',
  task: '작업 {id}',
  mainTask: '주 작업',
  unassignedScenes: '작업에 할당되지 않은 장면',
  scene: '장면 {id}',
  unnamedScene: '이름 없는 장면',
  sceneDescription: '장면 설명: {description}',
  nextScenes: '다음 장면: {scenes}',
  sceneTiming: '진입 후 판정 지연: {delay}초; 시간 제한: {timeout}초; 시간 초과 시 자동 스킵: {skip}',
  yes: '예',
  no: '아니요',
  none: '없음',
  and: '그리고',
  or: '또는',
  notConfigured: '설정되지 않음',
  noCondition: '조건이 설정되지 않음',
  noConditionGroup: '조건 그룹이 설정되지 않음',
  noPassCondition: '통과 판정 조건이 설정되지 않음',
  noPassConditionSentence: '통과 판정 조건이 설정되지 않았습니다.',
  noAction: '동작이 설정되지 않음',
  noActionSentence: '동작이 설정되지 않았습니다.',
  noPassAction: '통과 동작이 설정되지 않음',
  noPassActionSentence: '통과 동작이 설정되지 않았습니다.',
  passConditions: '통과 판정 조건',
  passCheck: '통과 판정',
  passActions: '통과 동작',
  action: '동작',
  actionBar: '동작 행',
  conditionalAction: '조건부 동작',
  conditionalPassAction: '조건부 통과 동작',
  trueActionBar: '조건 충족 시 동작 행',
  falseActionBar: '조건 미충족 시 동작 행',
  conditionMet: '조건 충족',
  conditionNotMet: '조건 미충족',
  executionCondition: '실행 조건: {condition}',
  condition: '조건 {id}: {condition}',
  nextConditionRelation: '; 다음 조건과 {relation}',
  delay: ' (지연 {seconds}초)',
  colon: ': ',
  comma: ', ',
  semicolon: '; ',
  actionSeparator: ', ',
  parentheses: ' ({text})',
  quote: '“{text}”',
  conditionText: '{device} {operation}',
  operationParameter: '{operation} {parameter}',
  deviceAction: '“{device}” {operation}',
  unknownDevice: '알 수 없는 장치',
  unknownAction: '알 수 없는 동작',
  unknownCondition: '알 수 없는 조건: {condition}',
  emptyCondition: '빈 조건',
  specifiedState: '지정 상태 도달',
  targetScene: '대상 장면 “{name}” (장면 {id})',
  parameterValue: '매개변수 값',
  brightness: '밝기',
  volume: '음량',
  priority: '우선순위',
  namedParameter: '{name}: “{value}”',
  additionalParameter: '추가 매개변수: “{value}”',
  parameterTarget: '매개변수 대상 ID: “{value}”',
  parameterHint: '매개변수 설명: “{hint}”',
  priorityHint: '값이 클수록 우선순위가 높습니다',
  languageHint: '0 기본값, 1 중국어, 2 광둥어, 3 영어, 4 일본어, 5 한국어',
  actionDescription: '; 동작 설명: “{description}”',
  nextSceneDescription: '다음 장면',
  noScenes: '현재 테마에 내보낼 장면이 없습니다',
  waitForScenes: '내보낼 장면이 없습니다. 테마 데이터 로딩이 완료될 때까지 기다려 주세요.',
  wordExported: '테마 진행 Word 문서를 내보냈습니다',
  xmindExported: '테마 진행 마인드맵을 내보냈습니다',
  exportFailed: '테마 진행 내보내기에 실패했습니다. 나중에 다시 시도해 주세요.',
}
